import { VStack } from '@chakra-ui/react';
import { FC, useContext } from 'react';
import EntityContext from '../../../context/EntityContext';
import { NearHotelTeaser } from '../../SiteSpecific/bikerbetten/NearHotelTeaser';

interface ActivityPoiNearHotelsProps {}

export const ActivityPoiNearHotels: FC<ActivityPoiNearHotelsProps> = ({}) => {
  const entityContext = useContext(EntityContext);

  if (!('nearHotels' in entityContext.entity)) {
    return null;
  }

  if (!entityContext.entity.nearHotels.total) {
    return null;
  }

  return (
    <VStack spacing={4}>
      {entityContext.entity.nearHotels?.items?.map((hotel, i) => (
        <NearHotelTeaser key={hotel.id} data={hotel} />
      ))}
    </VStack>
  );
};

export default ActivityPoiNearHotels;
